module.exports = require('./components/Modal');




//////////////////
// WEBPACK FOOTER
// ./~/react-modal/lib/index.js
// module id = 1048
// module chunks = 0